import { Component, type ReactNode } from 'react';
import type { Category } from '@atlassian/jira-servicedesk-knowledge-common/src/common/types.tsx';
import type { CategoriesResponse } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/categories/index.tsx';
import type { ConfluenceLinkState } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';

type Props = {
	isCategoriesSupported: boolean;
} & ConfluenceLinkState & {
		categories: Category[];
		children: ReactNode;
		setCategoriesData: (data: CategoriesResponse) => void;
		onSetKbHub: (data: ConfluenceLinkState) => void;
	};

// eslint-disable-next-line jira/react/no-class-components
export default class KnowledgeHubSetter extends Component<Props> {
	componentDidMount() {
		this.onSetKbHub();
		this.setCategoriesData();
	}

	componentDidUpdate() {
		this.onSetKbHub();
		this.setCategoriesData();
	}

	onSetKbHub() {
		const {
			onSetKbHub,
			setCategoriesData,
			children,
			categories,
			isCategoriesSupported,
			...confluenceLink
		} = this.props;
		onSetKbHub(confluenceLink);
	}

	setCategoriesData() {
		const { setCategoriesData, categories, isCategoriesSupported } = this.props;
		setCategoriesData({
			// TODO modernisation fix-types
			categories,
			categoriesSupported: isCategoriesSupported,
		});
	}

	render() {
		return this.props.children;
	}
}
